export default "__VITE_ASSET__BJOOrRYp__"